import {toast} from "./html-elements/toast";

export function standardResponse(responseCode, message = '') {
    switch (responseCode) {
        case '000':
            toast('Tölts ki minden mezőt a továbblépéshez!');
            break;
        case '001':
            toast(message);
            break;
        case '002':
            toast(message, 'warning');
            break;
        case '003':
            toast(message, 'error');
            break;
        case '200':
            toast('Az adatok mentése megtörtént.', 'success');
            break;
        case '204':
            toast('Nem történt változás az adatokban.');
            break;
        default:
            toast('Hiba történt az adatok mentése közben.', 'error');
            break;
    }
}